import React from 'react';

export const Logo = () => {
    return(
        <>
            <img width="90%" height="90%" src="/assets/Menhammar-Online-Sales-Logo.svg" className="custom-logo" alt="Menhammar OnlineSales" decoding="async" />
        </>
    );
}